import {BaseModel} from '../../core/base/base-model';
import {locateHostElement} from "@angular/core/src/render3/instructions";

export class Photo extends BaseModel {

    static getDefaultOwnerRating(data ={}) {
        return Object.assign({
            cameraSettings: 0,
            cameraSettings_text: null,
            composition: 0,
            composition_text: null,
            create_at: null,
            customerId: null,
            editing: 0,
            editing_text: null,
            general: 0,
            general_text: null,
            id: null,
            photoId: null,
            presentation: 0,
            presentation_text: null,
            vision: 0,
            vision_text: null
        }, data);
    }

    static getDefaultRating(data:any ={}) {
        return Object.assign({
            overal: 0,
            general: 0,
            general_count: 0,
            vision: 0,
            vision_count: 0,
            composition: 0,
            composition_count: 0,
            cameraSettings: 0,
            cameraSettings_count: 0,
            editing: 0,
            editing_count: 0,
            presentation: 0,
            presentation_count: 0,
            total: 0,
            cameraSettings_text_count : 0,
            composition_text_count : 0,
            editing_text_count : 0,
            presentation_text_count : 0,
            vision_text_count : 0,
            general_text_count : 0,
            total_rating : 0
        }, data);
    }

    id: number ;
    type: string
    photoRelated: string;
    wasRelated: string;
    isGolden: string;
    partner: any;
    partnerId: number;
    source: any;
    group: any;
    groupId: number;
    sourceId: number;
    categoryId: any;
    subCategory: any;
    subCategoryId: any;
    comments: any[];
    tags: any;
    story: any;
    vision: any;
    composition: any;
    cameraSettings: any;
    cameraType: any;
    editing: any;
    presentation: any;
    isEditorChoice: any;
    viewsCount: number;
    commentsCount: number;
    create_at: string;
    original: string;
    title: string;
    thumbnail: string;
    location: any;
    model: any;
    lens: any;
    locationId: any;
    focalLength: any;
    isPrimaryLocation:any;
    isGoldenLocation:any;
    aperture: any;
    ISO: any;
    lat: any;
    lng: any;
    shutterSpeed: any;
    height : number;
    width : number;
    navigateUrl: string;
    subType: string;
    localURL: string;
    likesCount : number;
    photoRewards: any
    customerId: number;
    traceLog: string;
    exif: {
        model: string;
        lens: any;
        focalLength: any;
        aperture: any;
        ISO: string;
        shutterSpeed: string;
        lat: any;
        lng: any;
    };

    category: {
        id: number,
        name: string,
        subId: string,
        subName: string,
        categoryType: string,
    };

    customer: {
        fullName: string,
        avatar: string,
        username: string,
        email: string,
        id: number,
        status: string,
        accessLevel: string,
        preferredLanguage: string,
    };

    ratings: {
        overal: number,
        general: number,
        general_count: number,
        vision: number,
        vision_count: number,
        composition: number,
        composition_count: number,
        cameraSettings: number,
        cameraSettings_count: number,
        editing: number,
        editing_count: number,
        presentation: number,
        total_rating : number
        presentation_count: number,
        total: number,
        cameraSettings_text_count : number,
        composition_text_count : number,
        editing_text_text_count : number,
        presentation_text_count : number,
        vision_text_text_count : number,
        general_text_count : number,
    };

    owner_rating: {
        cameraSettings: number,
        cameraSettings_text: string,
        composition: number,
        composition_text: string,
        create_at: string,
        customerId: number,
        editing: number,
        editing_text: string,
        general: number,
        general_text: string,
        id: string,
        photoId: number,
        presentation: number,
        presentation_text: string,
        vision: number,
        vision_text: string,
    };
    owner_rating_view: any;
    owner_like : boolean
}
